import React from "react";
import styles from "../categories_menu.module.css";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MENU_CATEGORIES_CHANGE } from "../../../services/actions/menu_categories_actions";


const MenuItem = ({ handleChangeVisibility, menuCategories, categorie }) => {

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch({
      type: MENU_CATEGORIES_CHANGE,
      payload: handleChangeVisibility(menuCategories, categorie.id, categorie.isOpen)
    });
  }

  return (
    <>
      {(categorie.children.length > 0 || categorie.count_products > 0) ?
        <div className={styles.link_container}>
          <NavLink
            to={`${categorie.path}`}
            className={({ isActive }) => (isActive ? styles.link__active : styles.link)}
            onClick={handleClick}
          >
            {categorie.name}
          </NavLink>
          {categorie.children.length > 0 &&
            <button className={styles.button} onClick={handleClick}>
              {categorie.isOpen ? '-' : '+'}
            </button>
          }
        </div>
        : null
      }

      {((categorie.children.length > 0 || categorie.count_products > 0) && categorie.isOpen) ?
        <ul className={styles.subList}>
          {categorie.children.map(item => {
            if (item.children.length || item.count_products) {
              return (
                <li key={item.id}>
                  <MenuItem
                    handleChangeVisibility={handleChangeVisibility}
                    menuCategories={menuCategories} categorie={item}
                  />
                </li>
              )
            }
            return null;
          })}
        </ul>
        : null
      }
    </>
  );
}

export default MenuItem;
